import { clients } from '@/services/client.factory'
import authstore from '@/store/modules/auth';

const mayor = {
    namespaced: true,
    state: {
        item: null,
        items: [],
        error: null,
        errors: {},
    },
    getters: {
        item: (state) => state.item,
        items: (state) => state.items,
        error: (state) => state.error,
        errors: (state) => state.errors,
    },
    mutations: {
        MAYOR_SET_ITEM(state, item) {
            Object.assign(state, { item })
        },
        MAYOR_CREATE_ITEM(state, item) {
            state.items.push(item);
        },
        MAYOR_UPDATE_ITEM(state, item) {
            Object.assign(state.items[item.editedIndex], item);
            //state.item = Object.assign({}, state.item, item)
        },
        MAYOR_SET_ITEMS(state, items) {
            Object.assign(state, { items })
        },
        MAYOR_SET_ERROR(state, error) {
            Object.assign(state, { error })
        },
        MAYOR_SET_ERRORS(state, errors) {
            Object.assign(state, { errors })
        },
        MAYOR_REMOVE_ITEM(state, item) {
            console.log("MAYOR_REMOVE_ITEM", state.items)
            console.log("itemmmmm", item)
            const index = state.items.findIndex(i => i.id === item.id);
            console.log("indexxx", index)
            state.items.splice(index, 1);
        }
    },
    actions: {
        getItem(context, id) {
        },
        async getMayor({ commit }) {
            console.log("Get Mayor is called from store.")
            let cityCode = authstore.getters.jwtDecoded(authstore.state).city_code;
            console.log("City Code = ", cityCode);
            await clients.placeServiceClient.getMayor(cityCode)
                .then((res) => {
                    console.log("Result of mayor get request: ", res);
                    commit('MAYOR_SET_ITEMS', res);
                })

            console.log("Get Mayor call is completed")
        },
        async createMayor({ commit }, mayor) {
            console.log("Create Mayor is called.")
            console.log("Mayor Object: ", mayor)
            let jwt = authstore.getters.jwtDecoded(authstore.state);
            let body = {
                "CityCode": jwt.city_code,
                "Name": mayor.name,
                "CVContent": mayor.cv,
                "ModificationDate": new Date(Date.now()).toISOString(),
                "OperatorId": jwt.preferred_username,
            }
            console.log("Body of the request is:", body)
            console.log("Before Mayor Create Request")
            await clients.placeServiceClient.addMayor(body)
                .then((res) => {
                    console.log("Result of mayor create request: ", res);
                    commit('MAYOR_SET_ITEMS', res);
                })
            console.log("After Mayor Create Request")
            //commit('PLACE_CREATE_ITEM', body);
        },
        
        async updateMayor({ commit }, mayor) {
            console.log("Mayor update is called.")
            let jwt = authstore.getters.jwtDecoded(authstore.state);
            let body = {
                cityCode: jwt.city_code,
                name: mayor.name,
                cvContent: mayor.cv,
                modificationDate: new Date(Date.now()).toISOString(),
                operatorId: jwt.preferred_username,
            }
            console.log("Update request body", body);
            console.log("Before Mayor Update Call")
            await clients.placeServiceClient.updateMayor(body)
                .then((res) => {
                    console.log("Result of mayor update request: ", res);
                    commit('MAYOR_SET_ITEMS', res);
                })
            console.log("After Mayor Update Call")

        },
        async deleteMayor({ commit }, mayor) {
            console.log("newsID", mayor.item.id)
            await clients.placeServiceClient.deleteNews(mayor.item.id);
            // commit('NEWS_REMOVE_ITEM', mayor.item);
        },
        async uploadMayorPhoto({ commit }, mayor) {
            console.log("Mayor Photo Upload is called, file = ", mayor)
            let jwt = authstore.getters.jwtDecoded(authstore.state);
            let file = {
                data: mayor.file,
                fileName: mayor.file.name
            }
            await clients.placeServiceClient.uploadMayorPhoto(jwt.city_code, file);
        },

        async deleteMayorPhoto({ commit }) {
            let jwt = authstore.getters.jwtDecoded(authstore.state);
            await clients.placeServiceClient.deleteMayorPhoto(jwt.city_code);
        },

    }
}

export default mayor;